// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.costSavingSettingsWrapper__YaL6s {
  position: relative;
  box-shadow: var(--basic-box-shadow);
}

.costSavingSettingsHeader__pljpf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--tables-primary-row-surface-default);
  padding: 15px 25px;
}

.costSavingSettingsTitle__RxH9C {
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
  color: var(--tables-title-text);
  margin: unset;
}

.costSavingSettingsTable__RooRK {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  display: grid;
  background: var(--tables-primary-row-surface-default);
}
.costSavingSettingsTable__RooRK thead {
  display: grid;
  position: relative;
}
.costSavingSettingsTable__RooRK tr {
  box-shadow: none;
  color: inherit;
  vertical-align: middle;
  outline: 0;
  display: flex;
}
.costSavingSettingsTable__RooRK td {
  padding: 10px 25px;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  white-space: normal;
  text-align: left;
  display: flex;
  width: 100%;
  align-items: center;
}
.costSavingSettingsTable__RooRK th {
  font-size: 11px;
  color: var(--tables-secondary-row-sub-title-text);
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  padding: 16px 25px;
  background: var(--tables-title-surface);
  text-align: left;
  display: flex;
  width: 100%;
  border-top: 1px solid var(--tables-title-stroke);
  border-bottom: 1px solid var(--tables-title-stroke);
}
.costSavingSettingsTable__RooRK .actionsColumn__A5dSU {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translate(0, -50%);
  width: unset;
  border: unset;
  padding: unset;
}
.costSavingSettingsTable__RooRK .emptyRow__t3Cry {
  display: table-row;
}
.costSavingSettingsTable__RooRK .emptyRow__t3Cry td {
  display: table-cell;
  text-transform: none;
}
@media (max-width: 1280px) {
  .costSavingSettingsTable__RooRK td {
    padding: 10px 12px;
  }
  .costSavingSettingsTable__RooRK th {
    padding: 16px 12px;
  }
}

.facilityColumn__v0L_F {
  max-width: 400px;
}
@media (max-width: 1280px) {
  .facilityColumn__v0L_F {
    max-width: 300px;
  }
}
@media (max-width: 900px) {
  .facilityColumn__v0L_F {
    max-width: 200px;
  }
}

.skeletonRow__OsBla td {
  padding-top: 16.5px;
  padding-bottom: 16.5px;
}

.skeletonText__wEdKS {
  height: 24px;
}

.searchPanel__drwcW {
  width: 300px;
}
@media (max-width: 1024px) {
  .searchPanel__drwcW {
    max-width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/MultiplicationFactors/components/CostSavingCalculationSettings/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,mCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qDAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,qDAAA;AAzEF;AA2EE;EACE,aAAA;EACA,kBAAA;AAzEJ;AA4EE;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;AA1EJ;AA6EE;EACE,kBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yDAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AA3EJ;AA8EE;EACE,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,gDAAA;EACA,mDAAA;AA5EJ;AA+EE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AA7EJ;AAgFE;EACE,kBAAA;AA9EJ;AAgFI;EACE,mBAAA;EACA,oBAAA;AA9EN;AAkFE;EACE;IACE,kBAAA;EAhFJ;EAmFE;IACE,kBAAA;EAjFJ;AACF;;AAqFA;EACE,gBAAA;AAlFF;AAoFE;EAHF;IAII,gBAAA;EAjFF;AACF;AAmFE;EAPF;IAQI,gBAAA;EAhFF;AACF;;AAoFE;EACE,mBAAA;EACA,sBAAA;AAjFJ;;AAqFA;EACE,YAAA;AAlFF;;AAqFA;EACE,YAAA;AAlFF;AAoFE;EAHF;IAII,gBAAA;EAjFF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.costSavingSettingsWrapper {\n  position: relative;\n  box-shadow: var(--basic-box-shadow);\n}\n\n.costSavingSettingsHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--tables-primary-row-surface-default);\n  padding: 15px 25px;\n}\n\n.costSavingSettingsTitle {\n  font-size: 11px;\n  font-weight: 400;\n  text-transform: uppercase;\n  color: var(--tables-title-text);\n  margin: unset;\n}\n\n.costSavingSettingsTable {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  display: grid;\n  background: var(--tables-primary-row-surface-default);\n\n  thead {\n    display: grid;\n    position: relative;\n  }\n\n  tr {\n    box-shadow: none;\n    color: inherit;\n    vertical-align: middle;\n    outline: 0;\n    display: flex;\n  }\n\n  td {\n    padding: 10px 25px;\n    color: var(--tables-secondary-row-sub-title-text);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 12px;\n    text-transform: uppercase;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    white-space: normal;\n    text-align: left;\n    display: flex;\n    width: 100%;\n    align-items: center;\n  }\n\n  th {\n    font-size: 11px;\n    color: var(--tables-secondary-row-sub-title-text);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n    padding: 16px 25px;\n    background: var(--tables-title-surface);\n    text-align: left;\n    display: flex;\n    width: 100%;\n    border-top: 1px solid var(--tables-title-stroke);\n    border-bottom: 1px solid var(--tables-title-stroke);\n  }\n\n  .actionsColumn {\n    position: absolute;\n    right: 25px;\n    top: 50%;\n    transform: translate(0, -50%);\n    width: unset;\n    border: unset;\n    padding: unset;\n  }\n\n  .emptyRow {\n    display: table-row;\n\n    td {\n      display: table-cell;\n      text-transform: none;\n    }\n  }\n\n  @media (max-width: 1280px) {\n    td {\n      padding: 10px 12px;\n    }\n\n    th {\n      padding: 16px 12px;\n    }\n  }\n}\n\n.facilityColumn {\n  max-width: 400px;\n\n  @media (max-width: 1280px) {\n    max-width: 300px;\n  }\n\n  @media (max-width: 900px) {\n    max-width: 200px;\n  }\n}\n\n.skeletonRow {\n  td {\n    padding-top: 16.5px;\n    padding-bottom: 16.5px;\n  }\n}\n\n.skeletonText {\n  height: 24px;\n}\n\n.searchPanel {\n  width: 300px;\n\n  @media (max-width: 1024px) {\n    max-width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"costSavingSettingsWrapper": `costSavingSettingsWrapper__YaL6s`,
	"costSavingSettingsHeader": `costSavingSettingsHeader__pljpf`,
	"costSavingSettingsTitle": `costSavingSettingsTitle__RxH9C`,
	"costSavingSettingsTable": `costSavingSettingsTable__RooRK`,
	"actionsColumn": `actionsColumn__A5dSU`,
	"emptyRow": `emptyRow__t3Cry`,
	"facilityColumn": `facilityColumn__v0L_F`,
	"skeletonRow": `skeletonRow__OsBla`,
	"skeletonText": `skeletonText__wEdKS`,
	"searchPanel": `searchPanel__drwcW`
};
module.exports = ___CSS_LOADER_EXPORT___;
